import { ReactTable } from './ReactTable';

export default ReactTable;
